/**
 * Barcode helpers shared by the scanner listener, the forms and the lookups.
 *
 * normalizeBarcode() must match public.normalize_barcode() in migration
 * 20260930000001: the database stores codes normalised, so a scan has to be
 * normalised the same way before it is compared.
 */

/** Trim, drop control characters, upper-case. Empty -> null. */
export function normalizeBarcode(value: string | null | undefined): string | null {
  if (value == null) return null;
  // eslint-disable-next-line no-control-regex
  const cleaned = value.replace(/[\u0000-\u001f\u007f]/g, '').trim().toUpperCase();
  return cleaned === '' ? null : cleaned;
}

const DUPLICATE_PREFIX = 'barcode_duplicate:';

/**
 * The uniqueness trigger rejects a duplicate with the message
 * "barcode_duplicate:<owner label>". Returns the owner label for such an
 * error message, or null for any other error.
 */
export function parseBarcodeDuplicate(message: string | null | undefined): string | null {
  if (!message) return null;
  const idx = message.indexOf(DUPLICATE_PREFIX);
  if (idx === -1) return null;
  return message.slice(idx + DUPLICATE_PREFIX.length).trim() || '?';
}

/** Short audio feedback for a scan. Silently does nothing where audio is unavailable. */
export function playScanFeedback(kind: 'ok' | 'error') {
  try {
    const Ctx = window.AudioContext || (window as any).webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const beep = (freq: number, start: number, duration: number) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'square';
      osc.frequency.value = freq;
      gain.gain.value = 0.05;
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(ctx.currentTime + start);
      osc.stop(ctx.currentTime + start + duration);
    };
    if (kind === 'ok') {
      beep(1320, 0, 0.08);
    } else {
      beep(220, 0, 0.12);
      beep(220, 0.18, 0.12);
    }
    setTimeout(() => ctx.close().catch(() => {}), 600);
  } catch {
    // no audio available
  }
}
